import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

const getRootVariable = (variable) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim()
}

const BrushSlider = styled(Slider)(({ railcolor, trackcolor, thumbcolor, bordercolor }) => ({
  color: trackcolor,
  height: '100%',
  margin: 0, 
  '& .MuiSlider-track': {
    backgroundColor: trackcolor,
    border: 'none',
  },
  '& .MuiSlider-rail': {
    opacity: 0.5,
    backgroundColor: railcolor,
  },
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: thumbcolor,
    border: `3.5px solid ${bordercolor}`,
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.1)',
    '&:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: '0 0 4px rgba(0, 0, 0, 0.2)',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    display: 'none',
  },
}));

const SizeSlider = ({ value, onChange }) => {
    const [colors, setColors] = useState({ 
        rail: '#eaecf0', 
        track: '#4b6b6f', 
        thumb: '#d1d5dc', 
        border: '#4b6b6f' 
    });

useEffect(() => {
    setColors({
      rail: getRootVariable('--gray-200'),
      thumb: getRootVariable('--gray-300'),
      track: getRootVariable('--green-700'),
      border: getRootVariable('--green-700'),
    })
  }, []);

  return (
    <Box sx={{ height: '90%'}}>
      <BrushSlider
        aria-label='Brush size'
        orientation="vertical"
        defaultValue={10}
        min={1}
        max={50}
        step={1}
        value={value}
        onChange={(e, newVal) => onChange(newVal)}
        railcolor={colors.rail}
        trackcolor={colors.track}
        thumbcolor={colors.thumb}
        bordercolor={colors.border}
      />
    </Box>
  )
}

export default SizeSlider